module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/chinese-6726fd6caf4dbb21.png"+" 48w",
        images: [{path: __webpack_public_path__ + "assets/images/chinese-6726fd6caf4dbb21.png",width: 48,height: 48}],
        src: __webpack_public_path__ + "assets/images/chinese-6726fd6caf4dbb21.png",
        toString: function(){return __webpack_public_path__ + "assets/images/chinese-6726fd6caf4dbb21.png"},
        
        width: 48,
        height: 48
      }